import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { LOGO_MANFRED } from 'utils/logos';
import { getPublicPath } from 'utils/paths';
import {
  StyledHeader,
  StyledLogo,
  StyledLogoManfred
} from './OutOfOfficeHeader.styled';

const OutOfOfficeHeader: React.FC = () => {
  const { t } = useI18n('out-of-office');

  return (
    <StyledHeader>
      <StyledLogo>
        <img
          src={getPublicPath('/images/outOfOffice/out-of-office.png')}
          alt="Out of office"
        />
        <StyledLogoManfred>
          <span>{t('out-of-office.header.offered-by')}</span>
          <img src={LOGO_MANFRED} alt="Manfred by Sngular" />
        </StyledLogoManfred>
      </StyledLogo>
      <Heading1>{t('out-of-office.header.title')}</Heading1>
      <HtmlTrans
        ns={'out-of-office'}
        i18nKey={'out-of-office.header.desc'}
      ></HtmlTrans>
    </StyledHeader>
  );
};

export default OutOfOfficeHeader;
